export * from './delete-fond.component';
export * from './delete-fond.component.module';